export default __webpack_public_path__ + "ca54b6613298e55677fdeeeb03b86891.svg";